/**
 * NotesTab — append-only meeting/interaction log (iter 170 split).
 *
 * Newest note pops to the top. Empty submissions ignored client-side; the
 * server also rejects with 422 for length<1 as a belt-and-suspenders.
 */
import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { relTime } from './formatters';

export function NotesTab({ notes, onAdd, busy }) {
  const [text, setText] = useState('');

  const submit = () => {
    if (!text.trim()) return;
    onAdd(text);
    setText('');
  };

  return (
    <div className="space-y-3">
      <div className="rounded-lg border border-slate-800 bg-slate-900/40 p-3">
        <textarea
          rows={3}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Meeting notes, call recap, quick thought…"
          className="w-full bg-slate-900 border border-slate-800 rounded-md px-3 py-2 text-sm text-slate-100 placeholder-slate-500 focus:outline-none focus:border-cn-primary/60"
          data-testid="crm-note-text"
        />
        <div className="flex justify-end mt-2">
          <Button
            size="sm"
            onClick={submit}
            disabled={busy || !text.trim()}
            data-testid="crm-add-note"
          >
            <Plus className="h-3.5 w-3.5 mr-1" /> Add note
          </Button>
        </div>
      </div>

      {notes.length === 0 ? (
        <p className="text-xs text-slate-500 italic">No notes yet. Log something above.</p>
      ) : notes.slice().reverse().map((n) => (
        <div
          key={n.id}
          className="rounded-lg border border-slate-800 bg-slate-900/40 p-3"
          data-testid={`crm-note-${n.id}`}
        >
          <div className="flex items-center gap-2 text-xs text-slate-500">
            <span className="font-medium text-slate-300">{n.by}</span>
            <span title={n.at}>{relTime(n.at)}</span>
          </div>
          <p className="mt-1 text-sm text-slate-100 whitespace-pre-wrap">{n.text}</p>
        </div>
      ))}
    </div>
  );
}

export default NotesTab;
